document.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('button[id^="open-"]')
	const teamsSection = document.querySelector('.teams')

	triggers?.forEach(trigger => {
		let identifier = trigger.getAttribute('id').split('-')[1]
		let body = document.getElementById(`staff-${identifier}`)
		let close = document.getElementById(`close-${identifier}`)

		body.setAttribute('style', '')

		trigger.addEventListener('click', () => {
			let currOpen = document.querySelector('.staff.open')
			if (currOpen && currOpen != body) {
				currOpen.classList.remove('open')
			}
			body.classList.add('open')
			teamsSection.classList.add('staff-open')
		})

		close.addEventListener('click', () => {
			body.classList.remove('open')
			teamsSection.classList.remove('staff-open')
		})
	})

	window.addEventListener('click', e => {
		if (!e.target.closest('.staff') && !e.target.closest('.arrow-link')) {
			document.querySelector('.staff.open')?.classList.remove('open')
			teamsSection.classList.remove('staff-open')
		}
	})
})
